export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6488.cebd5b60.jpg";